var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2273 8.36H14.5852V3.04C14.5852 1.36088 13.2016 0 11.4943 0H5.50568C3.79844 0 2.41477 1.36088 2.41477 3.04V8.36H0.772727C0.345312 8.36 0 8.69963 0 9.12V18.24C0 18.6604 0.345312 19 0.772727 19H16.2273C16.6547 19 17 18.6604 17 18.24V9.12C17 8.69963 16.6547 8.36 16.2273 8.36ZM9.17614 13.9888V15.2475C9.17614 15.352 9.0892 15.4375 8.98295 15.4375H8.01705C7.9108 15.4375 7.82386 15.352 7.82386 15.2475V13.9888C7.62453 13.848 7.47575 13.6487 7.39893 13.4195C7.32212 13.1902 7.32123 12.943 7.3964 12.7132C7.47157 12.4835 7.61892 12.2831 7.81724 12.141C8.01556 11.9989 8.25461 11.9223 8.5 11.9223C8.74539 11.9223 8.98444 11.9989 9.18276 12.141C9.38108 12.2831 9.52843 12.4835 9.6036 12.7132C9.67877 12.943 9.67788 13.1902 9.60106 13.4195C9.52425 13.6487 9.37547 13.848 9.17614 13.9888ZM12.8466 8.36H4.15341V3.04C4.15341 2.30612 4.75952 1.71 5.50568 1.71H11.4943C12.2405 1.71 12.8466 2.30612 12.8466 3.04V8.36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1135dd57709371aa8dbd877988dd69b0.svg";
export { ForwardRef as ReactComponent };